import React, { createContext, useContext } from 'react';

const TeamsEmbedContext = createContext(false);

export function TeamsEmbedProvider({
  embedded,
  children,
}: {
  embedded: boolean;
  children: React.ReactNode;
}) {
  return (
    <TeamsEmbedContext.Provider value={embedded}>
      {children}
    </TeamsEmbedContext.Provider>
  );
}

export function useTeamsEmbedded(): boolean {
  return useContext(TeamsEmbedContext);
}
